export default __webpack_public_path__ + "static/media/wastic.76e46f24.png";